exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shortcuts[data-v-0faf9bf9] .v-btn {\n  white-space: normal;\n}\n.shortcuts[data-v-0faf9bf9] .v-btn .v-btn__content {\n  flex: 1 1 auto;\n  text-align: center;\n}", ""]);

// exports
